import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme, IconButton, Dialog, useMediaQuery, useTheme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useModal } from 'hooks';

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    [theme.breakpoints.down('md')]: {
      margin: '67px 0 0 0',
    },
  },
  paper: {
    maxWidth: '1200px',
    minWidth: '320px',
    borderRadius: 0,
    [theme.breakpoints.up('lg')]: {
      width: '1000px',
    },
  },
  backdrop: {
    [theme.breakpoints.down('md')]: {
      top: '67px',
      width: '100%',
    },
  },
  closeButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      // display: 'none',
    },
  },
  closeButton: {
    padding: '18px',
  },
  closeIcon: {
    fontSize: '24px',
  },
  body: {
    padding: '0 50px 50px 50px',

    [theme.breakpoints.down('md')]: {
      padding: '0 15px 50px 15px',
    },
  },
}));

function LibraryModal() {
  const classes = useStyles();

  const { isOpen, onCloseModal, body } = useModal();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      aria-labelledby="library-modal"
      aria-describedby="library-modal"
      className={classes.dialog}
      PaperProps={{
        className: clsx(classes.paper),
      }}
      BackdropProps={{
        className: clsx(classes.backdrop),
      }}
      open={isOpen}
      fullScreen={fullScreen}
      onClose={onCloseModal}
    >
      <div className={classes.closeButtonContainer}>
        <IconButton onClick={onCloseModal} className={classes.closeButton}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </div>
      <section className={classes.body}>{body}</section>
    </Dialog>
  );
}

export default LibraryModal;
